import React from "react";
import Auth from "../auth/Auth";
import API from "../base/API";
import Storage from "../base/Storage";
import SorTable from '../base/SorTable';
import { translate } from "../base/Translation";
import { Link } from "react-router";
import { Page, PageHeader, PageBody } from "../base/Page";

export default class TopBottomList extends Auth {
    constructor(props) {
        super(props);

        this.api = new API({
            get_weave_groups: "/weave_group/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
            get_weaves: "/weave/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
            get_statistics: "/test/topBottom10/:weave?isGroup=:isGroup",
        });

        this.state = {
            weaves: [],
            statistics: [],
            tableData: [],
            selectedWeave: false,
            statsType: "weave_group",
            tableColumns: [
                { name: "index", display: translate("#"), sort: true, width: 5 },
                { name: "question", display: translate("Otázka"), sort: true, width: 25 },
                { name: "tests", display: translate("Testy"), sort: true, width: 30 },
                { name: "answer", display: translate("Odpoveď"), sort: true, width: 20 },
                { name: "count", display: translate("Počet"), sort: true, width: 10 },
                { name: "percent", display: translate("Percent"), sort: true, width: 10 },
            ]
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState){
        if(this.state.statsType !== prevState.statsType){
            this.fetchData();
        }
    }

    fetchData() {

        let brandFilter = Storage.get("brand_filter");
        this.api.request({
            cache: true,
            route: this.state.statsType === "weave" ? "get_weaves" : "get_weave_groups",
            params: { from: 0, to: 99999, withForms: true, brand: brandFilter ? brandFilter.id : "all" },
            success: (response) => {

                this.setState({ weaves: response, selectedWeave: response[0].id });

                this.loadStatistics(response[0].id);
            }
        });
    }

    loadStatistics(selectedWeave) {
        this.api.request({
            cache: true,
            route: "get_statistics",
            params: { from: 0, to: 99999, weave: selectedWeave, isGroup: this.state.statsType === "weave_group" ? 1 : 0 },
            success: (response) => {
                this.setState({ statistics: response.form_answer_counts });
            }
        });
    }

    convertDataForTable(data) {
        return data.map(function (statistic, index) {

            statistic.index = index + 1;
            statistic.tests = statistic.tests !== undefined ? statistic.tests.map((t, ti) => {
                return <Link key={"test_" + ti} to={"/tests/" + t.id} className="label label-primary">{t.name}</Link>
            }) : [];
            statistic.percent = (
                <span>
                    <span>{Math.round((parseInt(statistic.count, 10) / parseInt(statistic.test_count, 10) * 100))}</span>
                    <span> %</span>
                </span>
            );
            statistic.count = (
                <span>
                    <span>{statistic.count}</span>
                    <span> / {statistic.test_count}</span>
                </span>
            );

            return statistic;
        });
    }

    onFilter(evt) {
        this.setState({ selectedWeave: evt.target.value });
        this.loadStatistics(evt.target.value);
    }

    render() {

        return (
            <Page>
                <PageHeader title={translate("Top / bottom 10")} right={() => {
                    return (
                        <span>
                            <select
                                className="form-control input-sm pull-right"
                                style={{ maxWidth: "300px", marginLeft: "1rem" }}
                                onChange={this.onFilter.bind(this)}
                                value={this.state.selectedWeave}>
                                {this.state.weaves.map((weave) => {
                                    return <option key={weave.id} value={weave.id}>{weave.name}</option>
                                })}
                            </select>
                            <select
                                onChange={(e) => {
                                    this.setState({ statsType: e.target.value });
                                }}
                                className="form-control input-sm pull-right"
                                style={{ maxWidth: "300px", marginLeft: "1rem" }}
                                value={this.state.statsType}>
                                <option value="weave_group">{translate("Skupina vĺn")}</option>
                                <option value="weave">{translate("Vlna")}</option>
                            </select>
                        </span>
                    )
                }}>
                </PageHeader>
                <PageBody>
                    {this.state.statistics ? this.state.statistics.map((statistic) => {
                        let tableData = this.convertDataForTable(statistic.top_10);
                        return (
                            <div key={statistic.id} style={{ marginBottom: "3rem", borderBottom: "5px solid gray", paddingBottom: "3rem" }}>
                                <SorTable key={statistic.id} columns={this.state.tableColumns} data={tableData} headers={true} searchBy="name" title={statistic.name} />
                            </div>
                        )
                    }) : ""}
                </PageBody>
            </Page>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/top_bottom/TopBottomList.jsx